module.exports = __webpack_public_path__ + "static/media/worldMap.23ceaa23.png";